import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { Icon } from '@/ui/components/icon';
import { FolderIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import {
  FilesDetailPageBreadcrumbPage,
  FilesDetailPage,
} from '@/features/documents/components/files-page/files-detail-page';
import { documentVersionsQuery } from '@/features/documents/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/$documentId',
)({
  validateSearch: z.object({
    page: z.coerce.number().optional(),
  }),
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({ ...documentVersionsQuery(params.documentId), staleTime: 'static' }),
});

function RouteComponent() {
  const { projectId, workspaceId, documentId } = Route.useParams();
  const { page } = Route.useSearch();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <WorkspaceBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/files"
            params={{ projectId, workspaceId }}
          >
            <Icon icon={FolderIcon} />
            {t({ en: 'Files', nb: 'Filer' })}
          </BreadcrumbLink>
          <BreadcrumbPage>
            <FilesDetailPageBreadcrumbPage documentId={documentId} />
          </BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <FilesDetailPage documentId={documentId} pageStart={page} />
    </>
  );
}
